export const PUBLICATION_TAXONOMY = [
  {
    category: 'Business',
    subcategories: [
      'Local Business',
      'Founder Profiles',
      'Operators & Leadership',
      'Branding & Positioning',
      'Service Businesses',
      'Industry Profiles',
      'Business Strategy',
    ],
  },
  {
    category: 'Markets',
    subcategories: [
      'Regional Growth',
      'Investment Trends',
      'Consumer Trends',
      'Sector Signals',
      'Opportunity Mapping',
      'Economic Shifts',
      'Market Analysis',
    ],
  },
  {
    category: 'Culture',
    subcategories: [
      'Arizona Culture',
      'Entertainment',
      'Media & Influence',
      'Taste & Style',
      'Social Trends',
      'Identity & Place',
      'Cultural Commentary',
    ],
  },
  {
    category: 'Places',
    subcategories: [
      'Tucson',
      'Southern Arizona',
      'Arizona',
      'Southwest',
      'Neighborhoods',
      'Travel',
      'Destination Features',
    ],
  },
  {
    category: 'Experiences',
    subcategories: [
      'Food & Drink',
      'Hospitality',
      'Attractions',
      'Events',
      'Day Trips',
      'Service Experience',
      'Worth Visiting',
    ],
  },
  {
    category: 'Guides',
    subcategories: [
      'Local Guides',
      'Travel Guides',
      'Business Guides',
      'Strategy Guides',
      'Curated Lists',
      'Seasonal Guides',
      'How-To Features',
    ],
  },
  {
    category: 'Opinion',
    subcategories: [
      'Editorials',
      'Commentary',
      'Criticism',
      'Industry Takes',
      'Local Takes',
      'Essays',
      'Contrarian Views',
    ],
  },
  {
    category: 'Stories',
    subcategories: [
      'Profiles',
      'Interviews',
      'Longform Features',
      'Brand Stories',
      'Regional Stories',
      'Narrative Essays',
      'People & Places',
    ],
  },
  {
    category: 'Design',
    subcategories: [
      'Branding',
      'Visual Identity',
      'UI / UX',
      'Architecture & Space',
      'Creative Direction',
      'Design Critique',
      'Built Environment',
    ],
  },
  {
    category: 'Technology',
    subcategories: [
      'AI',
      'Software',
      'Digital Operations',
      'Tools & Platforms',
      'Tech for Business',
      'Tech & Society',
      'Emerging Technology',
    ],
  },
] as const;

const normalizeTaxonomyLabel = (value: string | null | undefined) => value?.trim().toLowerCase() ?? '';

export function getPublicationCategories(extraValues: readonly string[] = []) {
  const categories: string[] = [...PUBLICATION_TAXONOMY.map((entry) => entry.category)];

  extraValues.forEach((value) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    if (categories.some((entry) => normalizeTaxonomyLabel(entry) === normalizeTaxonomyLabel(trimmed))) return;
    categories.push(trimmed);
  });

  return categories;
}

export function findPublicationCategoryLabel(value: string | null | undefined) {
  const normalized = normalizeTaxonomyLabel(value);
  if (!normalized) return null;

  const match = PUBLICATION_TAXONOMY.find((entry) => normalizeTaxonomyLabel(entry.category) === normalized);
  return match?.category ?? null;
}

export function getPublicationSubcategories(
  category: string | null | undefined,
  extraValues: readonly string[] = [],
) {
  const categoryLabel = findPublicationCategoryLabel(category);
  const base: string[] =
    PUBLICATION_TAXONOMY.find((entry) => entry.category === categoryLabel)?.subcategories.map((entry) => entry) ?? [];

  const subcategories: string[] = [...base];

  extraValues.forEach((value) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    if (subcategories.some((entry) => normalizeTaxonomyLabel(entry) === normalizeTaxonomyLabel(trimmed))) return;
    subcategories.push(trimmed);
  });

  return subcategories;
}

export function findPublicationSubcategoryLabel(
  category: string | null | undefined,
  value: string | null | undefined,
) {
  const normalized = normalizeTaxonomyLabel(value);
  if (!normalized) return null;

  const subcategories = getPublicationSubcategories(category);
  const match = subcategories.find((entry) => normalizeTaxonomyLabel(entry) === normalized);
  return match ?? null;
}
